import React, { useState } from 'react';
import styled from 'styled-components';

const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContainer = styled.div`
    background-color: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    width: 90%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
`;

const Title = styled.h3`
    margin-top: 0;
    margin-bottom: 1.5rem;
    color: #333;
    font-size: 1.25rem;
    text-align: center;
`;

const InputGroup = styled.div`
    margin-bottom: 1rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: 500;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const StyledTextArea = styled.textarea`
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    min-height: 120px;
    resize: vertical;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 1.5rem;
`;

const Button = styled.button`
    padding: 0.6rem 1.2rem;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.2s;
    font-weight: 500;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const CancelButton = styled(Button)`
    background-color: #f8f9fa;
    color: #333;
    border: 1px solid #ddd;

    &:hover {
        background-color: #e2e6ea;
    }
`;

const SendButton = styled(Button)`
    background-color: #007bff;
    color: white;

    &:hover {
        background-color: #0056b3;
    }
`;

function PushNotificationModal({ isOpen, onClose, onSend, type, isLoading = false }) {
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');

    if (!isOpen) return null;

    const handleSend = () => {
        if (!title.trim() || !message.trim()) {
            alert('제목과 내용을 모두 입력해주세요.');
            return;
        }
        onSend(title, message);
        setTitle('');
        setMessage('');
    };

    const handleClose = () => {
        if (isLoading) return; // 로딩 중에는 닫기 방지
        setTitle('');
        setMessage('');
        onClose();
    }

    const modalTitle = type === 'all' ? '전체 푸쉬 알림 전송' : '선택 푸쉬 알림 전송';

    return (
        <Backdrop onClick={handleClose}>
            <ModalContainer onClick={(e) => e.stopPropagation()}>
                <Title>{modalTitle}</Title>
                <InputGroup>
                    <Label>제목</Label>
                    <StyledInput
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="알림 제목을 입력하세요"
                        disabled={isLoading}
                    />
                </InputGroup>
                <InputGroup>
                    <Label>내용</Label>
                    <StyledTextArea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="알림 내용을 입력하세요"
                        disabled={isLoading}
                    />
                </InputGroup>
                <ButtonGroup>
                    <CancelButton onClick={handleClose} disabled={isLoading}>취소</CancelButton>
                    <SendButton onClick={handleSend} disabled={isLoading}>
                        {isLoading ? '전송 중...' : '전송'}
                    </SendButton>
                </ButtonGroup>
            </ModalContainer>
        </Backdrop>
    );
}

export default PushNotificationModal;
